// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".btn[data-v-1d62b3fc] {\n  width: 200px;\n}\n.btn-transparent-blue[data-v-1d62b3fc] {\n  margin-bottom: 1rem;\n}\np[data-v-1d62b3fc] {\n  font-size: 0.9375rem;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
